import { AppState } from '..'
import { useAppSelector } from '../hooks'

export const useLocalAccountAddress = () => {
  return useAppSelector((state: AppState) => {
    return state.account.address
  })
}
